
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private readonly isEnabled = environment.loggerEnabled;

  log(message?: any, ...optionalParams: any[]): void {
    if (this.isEnabled) {
      console.log('[LOG]', message, ...optionalParams);
    }
  }

  warn(message?: any, ...optionalParams: any[]): void {
    if (this.isEnabled) {
      console.warn('[WARN]', message, ...optionalParams);
    }
  }

  error(message?: any, ...optionalParams: any[]): void {
    if (this.isEnabled) {
      console.error('[ERROR]', message, ...optionalParams);
    }
  }

  debug(message?: any, ...optionalParams: any[]): void {
    if (this.isEnabled && !environment.production) {
      console.debug('[DEBUG]', message, ...optionalParams);
    }
  }
}